export enum ScoreThreshold {
  Aspiring = 'Aspiring',
  Progressing = 'Progressing',
  Growing = 'Growing',
  Thriving = 'Thriving',
  Excellent = 'Excellent',
}

const SCORE_THRESHOLDS: {
  threshold: ScoreThreshold;
  min: number;
  max?: number;
  color: string;
}[] = [
  { threshold: ScoreThreshold.Aspiring, min: 0, max: 449, color: '#d5a6bd' },
  {
    threshold: ScoreThreshold.Progressing,
    min: 450,
    max: 549,
    color: '#ff9900',
  },
  { threshold: ScoreThreshold.Growing, min: 550, max: 649, color: '#ffe599' },
  { threshold: ScoreThreshold.Thriving, min: 650, max: 749, color: '#b6d7a8' },
  { threshold: ScoreThreshold.Excellent, min: 750, color: '#9fc5e8' },
];

export const getScoreColor = (score: number): string => {
  const match = SCORE_THRESHOLDS.find(
    (t) => score >= t.min && (t.max === undefined || score <= t.max)
  );

  return match?.color ?? '#d5a6bd';
};
